import React, { useState, useEffect } from 'react'
import { Horizontal, Vertical, Texto } from '@gravitate-js/excalibrr'
import { EnvironmentFilled, ExperimentFilled, UserSwitchOutlined } from '@ant-design/icons'
import { PriceExpand } from './PriceExpand'
import { GroupExpander } from './Intramonth/GroupExpander'
import { useDirectiveContext } from '../DirectiveContext'
import moment from 'moment'
import { DirectiveDeltaTag } from './DirectiveDeltaTag'
import classNames from 'classnames'

export const DirectiveRow = ({ directive, dataRows, resizeRow, updateRow, addPricesToRow, isMonthly }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { selectedDirective, selectDirective, selectedDate } = useDirectiveContext()
  const isSelected = selectedDirective?.curve_group_id === directive.curve_group_id
  const showTag = isMonthly && moment(selectedDate).isBefore(moment().endOf('day'))
  const onSelect = () => {
    if (directive.curve_ids.length !== 0) {
      setIsExpanded(!isSelected)
    }
    if (isSelected) {
      selectDirective(undefined)
    } else {
      selectDirective(directive)
    }
  }

  useEffect(() => {
    if (directive.prices) {
      setIsExpanded(true)
    } else {
      setIsExpanded(false)
    }
  }, [directive])
  return (
    <div>
      <div
        onClick={onSelect}
        className={classNames('border-bottom bg-1 directive-row', {
          selected: isSelected,
        })}
      >
        <Horizontal>
          <Vertical className='px-3 pt-3 bg-2' flex={3}>
            <Horizontal className='h-100'>
              <Vertical flex={2} style={{ minWidth: 140 }}>
                <GroupExpander
                  resizeRow={resizeRow}
                  isExpanded={isExpanded}
                  setIsExpanded={setIsExpanded}
                  directive={directive}
                />

                <Texto className='pt-2' weight='bold'>
                  <ExperimentFilled className='pr-2' /> {directive.product || 'Multiple Products'}
                </Texto>
                {showTag && <DirectiveDeltaTag className='pt-2' delta={directive.delta_to_directive || 0} />}
              </Vertical>
              <Vertical flex={2}>
                <Texto weight={directive.supplier ? 600 : 500}>
                  <UserSwitchOutlined className='pr-2' /> {directive.supplier || 'Multiple Suppliers'}
                </Texto>
                <Texto className='mt-2' weight={directive.terminal ? 600 : 500}>
                  <EnvironmentFilled className='pr-2' /> {directive.terminal || 'Multiple Terminals'}
                </Texto>
              </Vertical>
              <Vertical flex={1.25}>
                {dataRows.map((row, i) => (
                  <Texto
                    key={i}
                    weight='bold'
                    style={{ height: row.height }}
                    category='label'
                    appearance='medium'
                    align='right'
                  >
                    {row.title}{' '}
                    {row.title === 'WEEKLY' && `(${directive.week_start_day?.substring(0, 3)?.toUpperCase()})`}
                  </Texto>
                ))}
              </Vertical>
            </Horizontal>
          </Vertical>
          <Vertical className='px-3 pt-3 directive-stats' flex={4}>
            {dataRows.map((row, i) => (
              <row.RowComponent key={i} directive={directive} updateRow={updateRow} setIsExpanded={setIsExpanded} />
            ))}
          </Vertical>
        </Horizontal>
      </div>
      {isExpanded && <PriceExpand addPricesToRow={addPricesToRow} resizeRow={resizeRow} directive={directive} />}
    </div>
  )
}
